// AUTO-GENERATED da `scripts/optimize_avatars.py`.
// Lista nomi file in /public/avatars/<nome>.png
// Avatar specifici: 244 · Generico fallback: sì

export const AVATAR_NAMES: ReadonlySet<string> = new Set(["abankwah", "adopo", "adzic", "akanji", "alajbegovic", "amondarain", "atta", "badiashile", "bakola", "baldanzi", "barella", "bartesaghi", "bastoni", "baturina", "berardi", "bernardeschi", "bernasconi", "bertola", "beto", "beukema", "bijlow", "bisseck", "bonny", "bracaglia", "bremer", "britschgi", "buongiorno", "butez", "calhanoglu", "calo", "camarda", "cambiaghi", "cambiaso", "caprile", "caqueret", "carlosaugusto", "carnesecchi", "castro-s", "celik", "chalobah-t", "chukwueze", "cinquegrano", "cisse-a", "colombo", "comotto", "conceicao", "contini", "corvi", "couto", "cristante", "dacunha", "daffara", "davisk", "debruyne", "degea", "deketelaere", "delprato", "demarzi", "deroon", "desplanches", "dewinter", "diallo-o", "diao", "diawara-s", "diegocarlos", "digennaro", "dilorenzo", "dimarco", "diouf", "dominguez-b", "douvikas", "dovbyk", "dragusin", "drobnic", "dybala", "ederson-d-s", "ekhator", "ekkelenkamp", "espositofp", "estupinan", "favasuli", "fazzini", "ferguson", "frattesi", "gabbia", "gaetano", "ghedjemis", "ghilardi", "gila", "gilmour", "giovane", "gollini", "goncalves-p", "gonzalez-n", "grabara", "gudmundsson-a", "heggem", "helland", "henrique", "hermoso", "hojlund", "holm", "hutchinson", "idrissi-r", "jashari", "jimenez-a", "jones-c", "kabasele", "kaiki", "kalulu", "kamara-h", "karlstrom", "kean", "kessie", "kolasinac", "kolomuani", "kone-m", "koopmeiners", "kossounou", "kristensen-t", "krstovic", "kvernadze", "lang", "lauriente", "liberali", "lobotka", "loftuscheek", "lontani", "lucca", "lucumi", "lulli", "maignan", "maldini", "malen", "mancini", "mandas", "marcandalli", "marianucci", "marin-r", "martinez-jo", "martinez-l", "mastantuono", "matic", "mbangula", "mckennie", "mctominay", "mendy-p", "meret", "milinkovic-savic-v", "milla", "mitaj", "mkhitaryan", "modric", "molina-n", "mora", "moreira", "motta", "muric", "musah", "mussolini", "ndicka", "neres", "nicolussicaviglia", "njie", "obert", "obrador", "okoye", "olivera", "ordonez-c", "orsolini", "osmajic", "ostigard", "oyono-a", "palma", "palmisani", "pasalic", "pavard", "pavlovic", "paz-n", "pellegrino-m", "perrone", "pessinamas", "pinamonti", "piotrowski", "pisilli", "politano", "pompei", "provedel", "pulisic", "rabiot", "raimondo", "ramon", "ramos-g", "renzetti", "robinhojunior", "rodriguez-je", "rodriguez-ju", "romano", "romero-d", "rovella", "rowe", "rrahmani", "saelemaekers", "samardzic", "santos-a", "scalvini", "scamacca", "skorupski", "solet", "spence", "spinazzola", "sportiello", "stankovic-a", "stones", "sucic-p", "sugawara", "svilar", "tavares-n", "terracciano", "terracciano-f", "theate", "thuram-m", "tomori", "torriani", "troilo", "valdepenas", "valeri", "valle", "vanderbrempt", "vasquez", "vergara", "vicario", "viery", "vojvoda", "volpato", "wesley", "woltemade", "yildiz", "zaccagni", "zamboanguissa", "zaniolo", "zappacosta", "zepedro", "zielinski"]);

/** True se `/avatars/generico.png` esiste — fallback prima
 * delle iniziali nel PlayerAvatar. */
export const HAS_GENERIC_AVATAR = true;

/** Mapping nome file → nome originale per debug. */
export const AVATAR_ORIGINAL_NAMES: Record<string, string> = {
  "abankwah": "abankwah",
  "adopo": "adopo",
  "adzic": "adzic",
  "akanji": "akanji",
  "alajbegovic": "alajbegovic",
  "amondarain": "amondarain",
  "atta": "atta",
  "badiashile": "badiashile",
  "bakola": "bakola",
  "baldanzi": "baldanzi",
  "barella": "barella",
  "bartesaghi": "bartesaghi",
  "bastoni": "bastoni",
  "baturina": "baturina",
  "berardi": "berardi",
  "bernardeschi": "bernardeschi",
  "bernasconi": "bernasconi",
  "bertola": "bertola",
  "beto": "beto",
  "beukema": "beukema",
  "bijlow": "bijlow",
  "bisseck": "bisseck",
  "bonny": "bonny",
  "bracaglia": "bracaglia",
  "bremer": "bremer",
  "britschgi": "britschgi",
  "buongiorno": "buongiorno",
  "butez": "butez",
  "calhanoglu": "calhanoglu",
  "calo": "calo",
  "camarda": "camarda",
  "cambiaghi": "cambiaghi",
  "cambiaso": "cambiaso",
  "caprile": "caprile",
  "caqueret": "caqueret",
  "carlosaugusto": "carlosaugusto",
  "carnesecchi": "carnesecchi",
  "castro-s": "castro",
  "celik": "celik",
  "chalobah-t": "chalobah",
  "chukwueze": "chukwueze",
  "cinquegrano": "cinquegrano",
  "cisse-a": "cisse",
  "colombo": "colombo",
  "comotto": "comotto",
  "conceicao": "conceicao",
  "contini": "contini",
  "corvi": "corvi",
  "couto": "couto",
  "cristante": "cristante",
  "dacunha": "da cunha",
  "daffara": "daffara",
  "davisk": "davisk",
  "debruyne": "debruyne",
  "degea": "degea",
  "deketelaere": "deketelare",
  "delprato": "delprato",
  "demarzi": "demarzi",
  "deroon": "deroon",
  "desplanches": "desplanches",
  "dewinter": "dewinter",
  "diallo-o": "diallo",
  "diao": "diao",
  "diawara-s": "diawara",
  "diegocarlos": "diegocarlos",
  "digennaro": "digennaro",
  "dilorenzo": "dilorenzo",
  "dimarco": "dimarco",
  "diouf": "diouf",
  "dominguez-b": "dominguez b",
  "douvikas": "douvikas",
  "dovbyk": "dovbyk",
  "dragusin": "dragusin",
  "drobnic": "drobnic",
  "dybala": "dybala",
  "ederson-d-s": "ederson",
  "ekhator": "ekhator",
  "ekkelenkamp": "ekkelenkamp",
  "espositofp": "esposito fp",
  "estupinan": "estupinan",
  "favasuli": "favasuli",
  "fazzini": "fazzini",
  "ferguson": "ferguson",
  "frattesi": "frattesi",
  "gabbia": "gabbia",
  "gaetano": "gaetano",
  "ghedjemis": "ghedjemis",
  "ghilardi": "ghilardi",
  "gila": "gila",
  "gilmour": "gilmour",
  "giovane": "giovane",
  "gollini": "gollini",
  "goncalves-p": "goncalves",
  "grabara": "grabara",
  "gudmundsson-a": "gudmundsson",
  "heggem": "heggem",
  "helland": "helland",
  "henrique": "henrique",
  "hermoso": "hermoso",
  "hojlund": "hojlund",
  "holm": "holm",
  "hutchinson": "hutchinson",
  "idrissi-r": "idrissi",
  "jashari": "jashari",
  "rodriguez-je": "jesus rodriguez",
  "jimenez-a": "jimenez",
  "jones-c": "jones",
  "rodriguez-ju": "jurodriguez",
  "kabasele": "kabasele",
  "kaiki": "kaiki",
  "kalulu": "kalulu",
  "kamara-h": "kamara",
  "karlstrom": "karlstrom",
  "kean": "kean",
  "kessie": "kessie",
  "kolasinac": "kolasinac",
  "kolomuani": "kolomuani",
  "kone-m": "kone manu",
  "koopmeiners": "koopmeiners",
  "kossounou": "kossounou",
  "kristensen-t": "kristensen",
  "krstovic": "krstovic",
  "kvernadze": "kvernadze",
  "lang": "lang",
  "lauriente": "lauriente",
  "liberali": "liberali",
  "lobotka": "lobotka",
  "loftuscheek": "loftuscheek",
  "lontani": "lontani",
  "lucca": "lucca",
  "lucumi": "lucumi",
  "lulli": "lulli",
  "maignan": "maignan",
  "maldini": "maldini",
  "malen": "malen",
  "mancini": "mancini",
  "mandas": "mandas",
  "marcandalli": "marcandalli",
  "marianucci": "marianucci",
  "marin-r": "marin rafa",
  "martinez-jo": "martinez jo",
  "martinez-l": "martinez l",
  "mastantuono": "mastantuono",
  "matic": "matic",
  "mbangula": "mbangula",
  "mckennie": "mckennie",
  "mctominay": "mctominay",
  "mendy-p": "mendy",
  "meret": "meret",
  "milla": "milla",
  "mitaj": "mitaj",
  "mkhitaryan": "mkhitaryan",
  "modric": "modric",
  "molina-n": "molina",
  "mora": "mora",
  "moreira": "moreira",
  "motta": "motta",
  "muric": "muric",
  "musah": "musah",
  "mussolini": "mussolini",
  "ndicka": "ndicka",
  "neres": "neres",
  "gonzalez-n": "nicogonzalez",
  "nicolussicaviglia": "nicolussicaviglia",
  "njie": "njie",
  "obert": "obert",
  "obrador": "obrador",
  "okoye": "okoye",
  "olivera": "olivera",
  "ordonez-c": "ordonez",
  "orsolini": "orsolini",
  "osmajic": "osmajic",
  "ostigard": "ostigard",
  "oyono-a": "oyono",
  "palma": "palma",
  "palmisani": "palmisani",
  "pasalic": "pasalic",
  "pavard": "pavard",
  "pavlovic": "pavlovic",
  "paz-n": "paz",
  "pellegrino-m": "pellegrino",
  "perrone": "perrone",
  "pessinamas": "pessina mass",
  "pinamonti": "pinamonti",
  "piotrowski": "piotrowski",
  "pisilli": "pisilli",
  "politano": "politano",
  "pompei": "pompei",
  "provedel": "provedel",
  "pulisic": "pulisic",
  "rabiot": "rabiot",
  "raimondo": "raimondo",
  "ramon": "ramon",
  "ramos-g": "ramos",
  "renzetti": "renzetti",
  "robinhojunior": "robinhojr",
  "romano": "romano",
  "romero-d": "romero",
  "rovella": "rovella",
  "rowe": "rowe",
  "rrahmani": "rrhamani",
  "saelemaekers": "saelemaekers",
  "samardzic": "samardzic",
  "santos-a": "santos",
  "milinkovic-savic-v": "savic milinkovic",
  "scalvini": "scalvini",
  "scamacca": "scamacca",
  "skorupski": "skorupski",
  "solet": "solet",
  "spence": "spence",
  "spinazzola": "spinazzola",
  "sportiello": "sportiello",
  "stankovic-a": "stankovic a",
  "stones": "stones",
  "sucic-p": "sucic",
  "sugawara": "sugawara",
  "svilar": "svilar",
  "tavares-n": "tavares",
  "terracciano-f": "terracciano f",
  "terracciano": "terracciano p",
  "theate": "theate",
  "thuram-m": "thuram m",
  "tomori": "tomori",
  "torriani": "torriani",
  "troilo": "troilo",
  "valdepenas": "valdepenas",
  "valeri": "valeri",
  "valle": "valle",
  "vanderbrempt": "vanderbrempt",
  "vasquez": "vasquez",
  "vergara": "vergara",
  "vicario": "vicario",
  "viery": "viery",
  "vojvoda": "vojvoda",
  "volpato": "volpato",
  "wesley": "wesley",
  "woltemade": "woltemade",
  "yildiz": "yildiz",
  "zaccagni": "zaccagni",
  "zamboanguissa": "zamboanguissa",
  "zaniolo": "zaniolo",
  "zappacosta": "zappacosta",
  "zepedro": "zepedro",
  "zielinski": "zielinski"
};
